module.exports = __webpack_public_path__ + "static/media/vehiculosRamos.9c60bdb4.jpg";